.ai{flex-shrink:0;}